import {Button, Divider, Flex, Modal, Typography} from "antd";
import { useState} from "react";
import "./ScriptDialogs.css"
import {Voucher} from "../../../models/Info/voucher.model";
import {PracticeDetail} from "../../../models/Practice/PracticeDetail";

export interface ScriptDialogsProps{
    insuranceProviderId:number,
    voucher: Voucher;
    detail: PracticeDetail | undefined;
}
export function ScriptDialogs(props:ScriptDialogsProps){
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { Text } = Typography;
    const [currentTitle, setCurrentTitle] = useState<string>("");
    const [currentScriptText, setCurrentScriptText] = useState<string>("");
    // const [operator,setOperator] = useState<Employee | null> (AuthService.getOperatorOnline());

    // const getMainShopName=()=>{
    //     switch (props.voucher.company) {
    //         case "SV":
    //             return "Salmoiraghi & Vigano ";
    //         case "GV":
    //             return "Grand Vision ";
    //     }
    // }

    // const getLocalShopName=()=>{
    //     const localShopName = props.detail?.shopName;
    //     if(localShopName)
    //         return capitalizeWords(localShopName.split("-")[1]);
    // }

    // function capitalizeWords(val: string): string {
    //     return val.toLowerCase()
    //         .split(/(\s|\.)/)
    //         .map(word => word ? word.charAt(0).toUpperCase() + word.slice(1) : word)
    //         .join('');
    // }

    // Scripts
    const MESSAGES = {
        RECAL_CLIENTI: {
            TITLE:"Script per recall clienti",
            SALMOIRAGHI_VIGANO: (
                <>
                    Buongiorno/Buonasera!
                    <br />
                    Sono *** del negozio Salmoiraghi & Viganò ***.
                    <br />
                    La contatto perché abbiamo preso in carico il suo voucher (nominare il Fondo);
                    grazie per aver scelto il nostro negozio!
                    <br />
                    Ci farebbe piacere invitarla nel nostro negozio per illustrarle tutti i servizi
                    e i vantaggi a lei dedicati grazie alla partnership tra la nostra azienda e (nominare il Fondo).
                    <br />
                    In particolare, potrà beneficiare di scontistiche riservate, della possibilità di
                    ottenere il rimborso per l’acquisto di lenti e/o occhiali da vista *e anche di un
                    extra rimborso aggiuntivo valido solo per gli acquisti presso i nostri negozi
                    (*<u>NB DA SPECIFICARE SOLO PER I PARTNER CHE LO PREVEDONO – CONSULTARE PAGINA INFO</u>).
                    <br />
                    <b>[SE IL FONDO NECESSITA DI VISITA OCULISTICA PER IL RIMBORSO]</b>
                    <br />
                    “nel nostro negozio, può inoltre beneficiare di uno sconto aggiuntivo (BONUS PREVENZIONE)
                    fino a 100€ rispetto al costo della visita oculistica. Questo sconto si cumula agli sconti
                    già previsti della convenzione!”
                    <br />
                    <b>[SE IL FONDO NECESSITA DI CAMBIO VISUS OTTICO]</b>
                    <br />
                    “nel nostro negozio, i nostri ottici effettuano gratuitamente il check up della vista,
                    può prenotare ora con me il suo appuntamento!"
                </>
            ),
            GRAND_VISION: (
                <>
                    Buongiorno/Buonasera!
                    <br />
                    La contatto perché abbiamo preso in carico il suo voucher (nominare il Fondo);
                    innanzitutto grazie per aver scelto il nostro negozio!
                    <br />
                    Ci farebbe piacere invitarla nel nostro negozio per illustrarle tutti i servizi e
                    i vantaggi a lei dedicati grazie alla partnership tra la nostra azienda e (nominare il Fondo).
                    <br />
                    In particolare, potrà beneficiare di scontistiche riservate, della possibilità di ottenere
                    il rimborso per l’acquisto di lenti e/o occhiali da vista *e anche di un extra rimborso
                    aggiuntivo valido solo per gli acquisti presso i nostri negozi (*<u>NB DA SPECIFICARE SOLO PER
                    I PARTNER CHE LO PREVEDONO – CONSULTARE PAGINA INFO</u>).
                    <br />
                    Ha già la prescrizione di un oculista? (…)
                    <br />
                    Nel nostro negozio, i nostri ottici effettuano gratuitamente il check up della vista, può prenotare ora con me il suo appuntamento.
                    <br />
                    Quando le farebbe piacere venire a trovarci?
                </>
            )
        },
        WHATSAPP_BUSINESS: {
            TITLE:"Script Whatsapp business",
            SALMOIRAGHI_VIGANO: (
                <>
                    "Gentile cliente,
                    <br/>
                    sono "***" del negozio di "***" e le confermiamo l’apertura della sua pratica presso il nostro punto
                    vendita, grazie per aver scelto il nostro negozio!
                    <br/>
                    Ci farebbe piacere invitarla nel nostro negozio per illustrarle tutti i servizi e i vantaggi a lei
                    dedicati grazie alla partnership tra la nostra azienda e (nominare il Fondo).
                    <br/>
                    In particolare, potrà beneficiare di scontistiche riservate, della possibilità di ottenere il
                    rimborso per l’acquisto di lenti e/o occhiali da vista *e anche di un extra rimborso aggiuntivo
                    valido solo per gli acquisti presso i nostri negozi (*<u>NB DA SPECIFICARE SOLO PER I PARTNER CHE
                    LO PREVEDONO – CONSULTARE PAGINA INFO</u>).
                    <br/>
                    La invitiamo a rispondere a questo messaggio per fissare un appuntamento per poterle garantire
                    il miglior servizio.
                    <br/>
                    Le ricordiamo che, ha inoltre diritto a:
                    <br/>
                    <ul>
                        <li>Check-up della vista gratuito con uno dei nostri ottici</li>
                        <li>Prima applicazione di lenti a contatto gratuita</li>
                        <li>Fino a100€ di rimborso per la sua visita oculistica presentando la fattura</li>
                    </ul>
                    Se lo desidera, può prenotare direttamente online cliccando al seguente link, selezionando il nostro
                    negozio:
                    <br/>
                    <a href="https://www.salmoiraghievigano.it/esame-della-vista-scegli-negozio">
                        https://www.salmoiraghievigano.it/esame-della-vista-scegli-negozio
                    </a>
                    <br/>
                    A presto!
                    <br/>
                    Salmoiraghi & Viganò "***""
                </>
            ),
            GRAND_VISION:(
                <>
                    "Gentile cliente,
                    <br/>
                    sono “*** ” del negozio di “*** ” e le confermiamo l’apertura della sua pratica presso il nostro
                    punto vendita, grazie per aver scelto il nostro negozio!
                    <br/>
                    Ci farebbe piacere invitarla nel nostro negozio per illustrarle tutti i servizi e i vantaggi a
                    lei dedicati grazie alla partnership tra la nostra azienda e (nominare il Fondo).
                    <br/>
                    In particolare, potrà beneficiare di scontistiche riservate, della possibilità di ottenere il
                    rimborso per l’acquisto di lenti e/o occhiali da vista *e anche di un extra rimborso aggiuntivo
                    valido solo per gli acquisti presso i nostri negozi (*<u>NB DA SPECIFICARE SOLO PER I PARTNER CHE
                    LO PREVEDONO – CONSULTARE PAGINA INFO</u>).
                    <br/>
                    La invitiamo a rispondere a questo messaggio per fissare un appuntamento per poterle garantire il miglior servizio.
                    <br/>
                    Le ricordiamo che ha diritto a:
                    <br/>
                    <ul>
                        <li>Check-up della vista gratuito con uno dei nostri ottici</li>
                        <li>Prima applicazione di lenti a contatto gratuita</li>
                    </ul>
                    Se lo desidera, può prenotare direttamente online cliccando al seguente link, selezionando il nostro
                    negozio:
                    <br/>
                    <a href="https://www.grandvision.it/it-it/trova-negozi">
                        https://www.grandvision.it/it-it/trova-negozi
                    </a>
                    <br/>
                    A presto!
                    <br/>
                    GrandVision “***”
                </>
            )
        },
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const showModal = (script:any) => {
        setCurrentTitle(script.TITLE)
        switch (props.voucher.company) {
            case "SV":
            case "SVF":
                setCurrentScriptText(script["SALMOIRAGHI_VIGANO"]);
                break
            case "GV":
                setCurrentScriptText(script["GRAND_VISION"]);
                break
            default:
                return;
        }
        setIsModalOpen(true);
    };



    function getFooter():React.ReactNode {
        return <></>
    }

    return <div>
        <Flex gap={5}>
            <Button type={"primary"}  onClick={()=>{showModal(MESSAGES.RECAL_CLIENTI)}}>{MESSAGES.RECAL_CLIENTI.TITLE}</Button>
            <Button type={"primary"}  onClick={()=>{showModal(MESSAGES.WHATSAPP_BUSINESS)}}>{MESSAGES.WHATSAPP_BUSINESS.TITLE}</Button>
        </Flex>
        <Modal className={"scripts-dialog-modal"} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={getFooter()}>
            <div className={"body-modal"}>
                <Text strong>{currentTitle}</Text>
                <Divider className={"divider"} ></Divider>
                <div className={"script-elements-container"}>
                    {currentScriptText}
                </div>

            </div>

        </Modal>
    </div>
}
